export default {
  errorsRootKey: 'providers',
  resource: 'providers',
  actions: ['index', 'create']
}
